export default __webpack_public_path__ + "static/media/fightingAI.bf69a5da.PNG";